
import React from "react";
import { useThemeMode } from "../../../context/contextTheme";
import { useDesign } from '../../../context/contextDesign';
import { useChat } from '../../../context/contextChat';

const EpssCard = ({ epssTable }) => {
  const { theme } = useThemeMode();
  const { toggleEpssCard } = useDesign();

  return (
    <div className="profile-card position-absolute top-50 start-50 translate-middle 
        z-3 d-flex py-3 pb-4 rounded-4 shadow-lg"
      style={{
        height: 600, width: 1000,
        maxHeight: '80vh', maxWidth: '90vw',
        border: `1px solid ${theme.border}`,
        backgroundColor: theme.background,
        color: theme.textColor
      }}>
      <div className="card-body d-flex flex-column">
        <CVETable epssTable={epssTable} />
      </div>
      <div className="position-absolute top-0 end-0 p-4"        >
        <i className="bi bi-x-lg px-2 py-1 rounded-3"
          style={{
            fontSize: 20,
            cursor: 'pointer',
            backgroundColor: theme.primary
          }}
          onClick={toggleEpssCard} />
      </div>
    </div>
  );
};
export default EpssCard;

const CVETable = ({ epssTable }) => {
  const { theme } = useThemeMode();
  const { openVulnerabilityActions } = useChat();
  const { toggleEpssCard } = useDesign();
  const handleOnClickCVE = async (data) => {
    toggleEpssCard();
    openVulnerabilityActions(data);
  };

  return (
    <>
      <div className="table-responsive px-4 scrollbar-all-primary mt-4 h-100">
        <div className="mb-3 pe-5">
          <h4 className="fw-bold mb-1" style={{ color: theme.textColor }}>
            CVE Exploit Probability
          </h4>
          <p className="small mb-0" style={{ color: theme.textMuted }}>
            EPSS information is shown only for findings linked to a verified CVE ID.
          </p>
        </div>
        {epssTable && epssTable.length > 0 ? (
          <table className="table table-striped table-hover"
            style={{
              backgroundColor: theme.background2
            }}>
            <thead>
              <tr style={{
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: 'bold',
                position: 'sticky',
                top: 0, zIndex: 2,
              }}>
                <th style={{ width: '15%' }}>CVE ID</th>
                <th style={{ width: '10%' }}>EPSS</th>
                <th style={{ width: '10%' }}>Severity</th>
                <th style={{ width: '13%' }}>Exploitability</th>
                <th style={{ width: '8%' }}>Impact</th>
                <th style={{ width: '13%' }}>Confidentiality</th>
                <th style={{ width: '10%' }}>Integrity</th>
                <th style={{ width: '10%' }}>Availability</th>
                <th style={{ width: '10%' }}>Base Score</th>
              </tr>
            </thead>
            <tbody>
              {[...epssTable]
                .sort((a, b) => Number(b.epss) - Number(a.epss)) // Sorting by EPSS in descending order
                .map((cve, index) => (
                  <tr key={index} style={{
                    fontSize: '12px', textAlign: 'center'
                  }}>
                    <td className="text-start">
                      <span
                        className="badge cve-badge py-2"
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          width: "100%",
                          backgroundColor: theme.secondary,
                        }}
                        onClick={() =>
                          handleOnClickCVE({
                            cveId: cve.cveId,
                            epss: cve.epss,
                            severity: cve.baseSeverity,
                            exploitability: cve.exploitability,
                            impact: cve.impact,
                            confidentiality: cve.confidentiality,
                            integrity: cve.integrity,
                            availability: cve.availability,
                            baseScore: cve.baseScore,
                            remediation: cve.remediation,
                          })
                        }
                      >
                        {cve.cveId}
                      </span>
                    </td>
                    <td>{Number(cve.epss).toFixed(6)}</td>
                    <td>{cve.baseSeverity}</td>
                    <td>{Number(cve.exploitability).toFixed(2)}</td>
                    <td>{Number(cve.impact).toFixed(2)}</td>
                    <td>{cve.confidentiality}</td>
                    <td>{cve.integrity}</td>
                    <td>{cve.availability}</td>
                    <td>{Number(cve.baseScore).toFixed(1)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div
            className="h-75 d-flex flex-column align-items-center justify-content-center text-center px-4"
            style={{ color: theme.textColor }}
          >
            <i className="bi bi-info-circle fs-1 mb-3" style={{ color: theme.primary }} />
            <h5 className="fw-bold">No CVE or EPSS information available</h5>
            <p className="mb-0" style={{ color: theme.textMuted, maxWidth: 520 }}>
              This scan contains web-security findings, but none are linked to a verified CVE ID.
              EPSS applies only to published CVEs.
            </p>
          </div>
        )}
      </div>
      <style>{`
      .table>:not(caption)>*>* {
        background-color: ${theme.background};
        color: ${theme.textColor};
      }
    `}</style>
    </>
  );
};
